import { useSelector } from 'react-redux';
import { TransactionItem } from '../../redux/localReports/localReports.proptype';
import { selectSelectedTransactions } from '../../selectors';

export const useSelectedTransactions = (): TransactionItem[] => {
  const selectedTransactions = useSelector(selectSelectedTransactions);

  return selectedTransactions;
};
